var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_158_1060)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.228516,
    y: 0.80957,
    width: 100,
    height: 100,
    rx: 50,
    fill: "#BCF13C"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.551 60.8096V56.3096C42.551 55.3696 42.701 54.5496 43.001 53.8496C43.321 53.1496 43.821 52.5296 44.501 51.9896C45.181 51.4296 46.081 50.9096 47.201 50.4296L50.741 48.8996C51.641 48.5196 52.301 48.0496 52.721 47.4896C53.161 46.9296 53.381 46.2196 53.381 45.3596C53.381 44.4796 53.111 43.7596 52.571 43.1996C52.031 42.6396 51.241 42.3596 50.201 42.3596C49.161 42.3596 48.371 42.6496 47.831 43.2296C47.291 43.8096 47.021 44.5896 47.021 45.5696H42.251C42.251 44.1896 42.551 42.9496 43.151 41.8496C43.751 40.7296 44.641 39.8496 45.821 39.2096C47.001 38.5696 48.461 38.2496 50.201 38.2496C51.941 38.2496 53.391 38.5596 54.551 39.1796C55.731 39.7996 56.621 40.6296 57.221 41.6696C57.841 42.7096 58.151 43.8796 58.151 45.1796V45.5396C58.151 47.2196 57.691 48.6096 56.771 49.7096C55.851 50.7896 54.431 51.7496 52.511 52.5896L49.001 54.1196C48.401 54.3796 47.971 54.6496 47.711 54.9296C47.471 55.2096 47.351 55.5896 47.351 56.0696V57.5696L46.181 56.5796H58.181V60.8096H42.551Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_158_1060",
    x: 0.228516,
    y: 0.80957,
    width: 110,
    height: 110,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 10,
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.78 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_158_1060"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwo);
export default __webpack_public_path__ + "static/media/two.eaafa777e2055cb1c8bfbb4c53e300e7.svg";
export { ForwardRef as ReactComponent };